import React from "react";
import {
  Card,
  CardBody,
  CardHeader,
  Typography,
  Chip,
} from "@material-tailwind/react";
import moment from "moment";
import { useTranslation } from "react-i18next";

const RecentPayments = ({ data = [] }) => {
  const { t } = useTranslation("home");

  const formatCurrency = (amount) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "SAR",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount || 0);

  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "green";
      case "pending":
        return "amber";
      case "rejected":
        return "red";
      default:
        return "blue-gray";
    }
  };

  return (
    <Card className="shadow-md">
      <CardHeader
        floated={false}
        shadow={false}
        className="rounded-none bg-white px-6 py-4"
      >
        <Typography variant="h5">
          {t('recentPayments.title')}
        </Typography>

        <Typography variant="small" color="gray">
          {t('recentPayments.description')}
        </Typography>
      </CardHeader>

      <CardBody className="px-0 pt-0 overflow-x-auto">
        <table className="w-full min-w-max table-auto">
          <thead>
            <tr>
              <th className="border-b bg-blue-gray-50 p-4 text-left">
                {t('recentPayments.orderId')}
              </th>

              {/* <th className="border-b bg-blue-gray-50 p-4 text-left">
                Company
              </th> */}

              <th className="border-b bg-blue-gray-50 p-4 text-center">
                {t('recentPayments.paymentMode')}
              </th>

              <th className="border-b bg-blue-gray-50 p-4 text-right">
                {t('recentPayments.amount')}
              </th>

              {/* <th className="border-b bg-blue-gray-50 p-4 text-center">
                Status
              </th> */}

              <th className="border-b bg-blue-gray-50 p-4 text-center">
                {t('recentPayments.date')}
              </th>
            </tr>
          </thead>

          <tbody>
            {data.length === 0 && (
              <tr>
                <td
                  colSpan={6}
                  className="p-6 text-center text-gray-500"
                >
                  {t('recentPayments.noPaymentsFound')}
                </td>
              </tr>
            )}

            {data.map((payment) => (
              <tr
                key={payment.id}
                className="hover:bg-blue-gray-50 transition"
              >
                <td className="p-4 font-medium">
                  {payment?.rfq?.rfq_reference}
                </td>

                {/* <td className="p-4">
                  {payment?.user?.company_name}
                </td> */}

                <td className="p-4 text-center">
                  {payment.payment_mode_name}
                </td>

                <td className="p-4 text-right font-semibold text-green-600">
                  {formatCurrency(payment.amount_paid)}
                </td>

                {/* <td className="p-4 text-center">
                  <Chip
                    value={payment.status}
                    color={getStatusColor(payment.status)}
                    size="sm"
                    className="mx-auto w-fit"
                  />
                </td> */}

               <td className="p-4 text-center">
                  {moment(payment.created_at).format("DD MMM YYYY, hh:mm A")}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </CardBody>
    </Card>
  );
};

export default RecentPayments;